import cn from "classnames";
import Select from "components/shared/select";
import format from "date-fns/format";
import ru from "date-fns/locale/ru";
import { parseDateString } from "helpers/date";
import React from "react";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import { components } from "react-select";
import { list as timezones } from "sources/books/timezones";
import Template from "./template";

const dateTimeFormat = "yyyy-MM-dd'T'HH:mm:ssxxx";

const ValueContainer = (props) => {
    const { children, getValue, hasValue } = props;
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    const value = getValue()[0];
    if (!value || !value.option) {
        return <components.ValueContainer {...props} />;
    }
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>{value.option.utcOffset}</components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

export default class Datetime extends Template {
    componentDidMount() {
        const { value } = this.props;
        this.setState(this.initialState);
        this.validate(value, { isValid: true });
    }

    componentDidUpdate(prevProps) {
        const { timeOffset, validators, value } = this.props;
        if (timeOffset !== prevProps.timeOffset || value !== prevProps.value || validators !== prevProps.validators) {
            this.validate(value);
        }
    }

    setValue = (data) => {
        const { inputProps, onChange } = this.props;
        const newValue = data ? format(data, dateTimeFormat) : "";
        this.validate(newValue);
        if (newValue === this.props.value) {
            return;
        }
        return onChange({ name: inputProps.name, value: newValue });
    };

    calcOptions = () => {
        const { inputProps, format } = this.props;
        const timeOptions = { timeCaption: "Время", showTimeSelect: true, timeIntervals: 5 };
        switch (inputProps.type) {
            case "custom":
                return { ...format };
            case "date":
                return { dateFormat: "dd.MM.yyyy" };
            case "time":
                return { timeFormat: "HH:mm", ...timeOptions, showTimeSelectOnly: true };
            default:
                return { dateFormat: "dd.MM.yyyy HH:mm", timeFormat: "HH:mm", ...timeOptions };
        }
    };

    formatValue = (value) => {
        if (value) {
            const toDate = new Date(value);
            if (!isNaN(toDate.getTime())) {
                return toDate;
            }
        }
        return null;
    };

    renderTimezoneSelect = () => {
        let value = `${this.props.timeOffset}:00`;
        if (value.charAt(0) === "+") {
            value = value.slice(1);
        }
        return (
            <div className="col-sm-4 col-md-3">
                <Select
                    unClearable
                    components={{ ValueContainer }}
                    inputProps={{ name: "timeOffset", autoComplete: "off" }}
                    url={timezones}
                    value={value}
                    valueKey="utcOffset"
                    propName="displayName"
                    menuPortalTarget={document.body}
                    onChange={this.props.onChange}
                />
            </div>
        );
    };

    onChangeRaw = (e) => this.setValue(parseDateString(e.target.value));

    renderField = () => {
        const { value, libOptions, inPortal, inputProps, index, separateTimeOffset, portalId = "entry" } = this.props;
        const tabIndex = this.context?.baseTabIndex || 0;
        const name = index === undefined ? inputProps.name : `${inputProps.name}_${index}`;

        const { inlineFormat, ...options } = this.calcOptions();

        const dateMask = inputProps.type === "date" ? "99.99.9999" : "99.99.9999 99:99";

        return (
            <>
                <DatePicker
                    customInput={
                        ["custom", "time"].includes(inputProps.type) ? undefined : <InputMask mask={dateMask} />
                    }
                    disabled={inputProps.disabled}
                    className="field-wrap__input"
                    onChange={this.setValue}
                    disabledKeyboardNavigation
                    selected={this.formatValue(value)}
                    popperClassName={inPortal ? "field-wrap__portal-popper" : "field-wrap__datetime-popper"}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    {...(libOptions || {})}
                    portalId={portalId}
                    {...options}
                    name={name}
                    autoComplete="off"
                    locale={ru}
                    tabIndex={tabIndex}
                    onChangeRaw={this.onChangeRaw}
                />

                {separateTimeOffset && this.renderTimezoneSelect()}
            </>
        );
    };

    render() {
        const { wrapper, inputBottomText, isHidden } = this.props;
        if (isHidden) {
            return null;
        }
        const fieldclasses = cn({
            "col-sm-8 col-md-9": !wrapper,
            [wrapper]: !!wrapper,
        });
        const cname = this.calcCname();
        const { order } = this.props;
        return (
            <div className={cname} style={order === undefined ? {} : { order }}>
                {this.renderLabel()}
                <div className={fieldclasses}>
                    {this.renderField()}
                    {inputBottomText}
                    {this.additionalText()}
                    {this.renderError()}
                </div>
            </div>
        );
    }
}
